import React from 'react';
import {NavLink} from 'react-router-dom';
import {Collapse, Nav} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {connect} from 'react-redux';
import {I18n} from '../../I18n/components/sidebar';
import {hasPermissionForAttribute, isPAFeaturesVisible, isSupportChatPermission} from "../../helpers/companyService";
import swal from "sweetalert";
import {fetchUsers} from "../../actions/usersActions";
import {USER} from "../../helpers/constants";

class Sidebar extends React.Component {

	constructor(props) {
		super(props);
		this.expandLogo = this.expandLogo.bind(this);
		this.activeRoute.bind(this);
		this.state = {
			// authentication: this.activeRoute("/authentication") !== "" ? true : false,
			// uicomponents: this.activeRoute("/ui-components") !== "" ? true : false,
			// samplepages: this.activeRoute("/sample-pages") !== "" ? true : false,
			// dashboardpages: this.activeRoute("/dahboards") !== "" ? true : false,
			// iconsPages: this.activeRoute("/icons") !== "" ? true : false,
			// formlayoutPages: this.activeRoute("/form-layouts") !== "" ? true : false,
			// formpickerPages: this.activeRoute("/form-pickers") !== "" ? true : false,
			attributes: this.activeRoute("/dahboard/attributes") !== "",
			users: this.activeRoute("/dahboard/users") !== "",
			market: this.activeRoute("/dahboard/market") !== "",
			home: this.activeRoute("/") !== ""
		};
	}

	componentDidMount() {
		const {authority} = this.props;
		if (authority === USER) {
			this.props.fetchUsers();
		}
	}

	/*--------------------------------------------------------------------------------*/
	/*To Expand SITE_LOGO With Sidebar-Menu on Hover                                  */
	/*--------------------------------------------------------------------------------*/
	expandLogo() {
		document.getElementById("logobg").classList.toggle("expand-logo");
	}
	/*--------------------------------------------------------------------------------*/
	/*Verifies if routeName is the one active (in browser input)                      */
	/*--------------------------------------------------------------------------------*/
	activeRoute(routeName) { return this.props.location.pathname.indexOf(routeName) > -1 ? 'selected' : ''; }

	getContactUsListItem = (prop, key) => {
		const lang = this.props.lang
		return (
			<li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'}
				key={key}>
				<div onClick={() => swal(I18n[lang].contactUsToAccessThis, "", "error")}
					 className="sidebar-link">
					<i className={prop.icon}/>
					<span className="hide-menu">{prop.name[lang]}</span>
				</div>
			</li>
		);
	}

	isHiddenItem = itemProps => {
        const {companies, authority} = this.props;
        return (itemProps.paFeature && !isPAFeaturesVisible(companies[0], authority))
			|| this.isHiddenItemByCompanyAttribute(itemProps)
            || this.isHiddenItemByUserAttribute(itemProps);
    }

	isHiddenItemByCompanyAttribute = itemProps => {
		const {companies, authority} = this.props;
		return itemProps.companyAttribute
			&& !hasPermissionForAttribute(companies[0], authority, itemProps.companyAttribute)
	}

	isHiddenItemByUserAttribute = itemProps => {
		const {users, authority} = this.props;
		return itemProps.userAttribute
			&& users
			&& users.length === 1
			&& !hasPermissionForAttribute(users[0], authority, itemProps.userAttribute)
	}

	render() {
		const {lang} = this.props;
		return (
			<aside className="left-sidebar" id="sidebarbg" data-sidebarbg={this.props.data.settings[0].sidebarbg} onMouseEnter={this.expandLogo} onMouseLeave={this.expandLogo}>
				<div className="scroll-sidebar">
					<PerfectScrollbar className="sidebar-nav">
						{/*--------------------------------------------------------------------------------*/}
						{/* Sidebar Menus will go here                                                */}
						{/*--------------------------------------------------------------------------------*/}
						<Nav id="sidebarnav">
							{this.props.routes.map((prop, key) => {
								if (prop.redirect || this.isHiddenItem(prop)) {
									return null;
								}
								else if (prop.navlabel && prop.companyTitle && this.props.companies) {
									return (
										<li className="nav-small-cap" key={key}>
											<i className={prop.icon}></i>
											<span className="hide-menu">
												{
													this.props.companies.length === 1 ? this.props.companies[0].name :
														prop.name[lang]
												}
											</span>
										</li>
									);
								}
								else if (prop.navlabel) {
									return (
										<li className="nav-small-cap" key={key}>
											<i className={prop.icon}></i>
											<span className="hide-menu">{prop.name[lang]}</span>
										</li>
									);
								}
								else if (prop.collapse) {
									let firstdd = {};
									firstdd[prop["state"]] = !this.state[prop.state];

									return (
										/*--------------------------------------------------------------------------------*/
										/* Menus wiil be goes here                                                        */
										/*--------------------------------------------------------------------------------*/
										<li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key}>
											<a data-toggle="collapse" className="sidebar-link has-arrow" aria-expanded={this.state[prop.state]} onClick={() => this.setState(firstdd)} >
												{prop.icon ? <i className={prop.icon}/> : ''}
												{prop.svgIcon ? <i><img alt="icon" src={prop.svgIcon} width="14"/></i> : ''}
												<span className="hide-menu">{prop.name[lang]}</span>
											</a>
											{/*--------------------------------------------------------------------------------*/}
											{/* Sub-Menus wiil be goes here                                                    */}
											{/*--------------------------------------------------------------------------------*/}
											<Collapse isOpen={this.state[prop.state]}>
												<ul className="first-level">
													{prop.child.map((prop, key) => {
														if (prop.redirect || this.isHiddenItem(prop)) return null;
														if (prop.collapse) {
															let seconddd = {};
															seconddd[prop["state"]] = !this.state[prop.state];
															return (
																<li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key} >
																	<a data-toggle="collapse" className="sidebar-link has-arrow" aria-expanded={this.state[prop.state]} onClick={() => this.setState(seconddd)} >
																		<i className={prop.icon} />
																		<span className="hide-menu">{prop.name[lang]}</span>
																	</a>
																	{/*--------------------------------------------------------------------------------*/}
																	{/* Sub-Menus wiil be goes here                                                    */}
																	{/*--------------------------------------------------------------------------------*/}
																	<Collapse isOpen={this.state[prop.state]}>
																		<ul className="second-level">
																			{prop.subchild.map((prop, key) => {
																				if (prop.redirect) return null;
																				return (
																					<li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key} >
																						<NavLink to={prop.path} activeClassName="active" className="sidebar-link">
																							<i className={prop.icon} />
																							<span className="hide-menu">{prop.name[lang]}</span>
																						</NavLink>
																					</li>
																				);
																			})}
																		</ul>
																	</Collapse>
																</li>
															);
														}
														return (
															/*--------------------------------------------------------------------------------*/
															/* Adding Sidebar Item                                                            */
															/*--------------------------------------------------------------------------------*/
															<li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'} key={key}>
																<NavLink to={prop.path} className="sidebar-link" activeClassName="active">
																	<i className={prop.icon} />
																	<span className="hide-menu">{prop.name[lang]}</span>
																</NavLink>
															</li>
														);
													})}
												</ul>
											</Collapse>
										</li>
									);
								}
								else if (prop.invisible) {
									return (
									""
									);
								} else if (prop.isLink) {
									if (!isSupportChatPermission(this.props.companies[0], this.props.authority))
										return this.getContactUsListItem(prop)

									return (
										<li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'}
											key={key}>
											<a href={prop.path} className="sidebar-link">
												<i className={prop.icon}/>
												<span className="hide-menu">{prop.name[lang]}</span>
											</a>
										</li>
									);
								} else {
									return (
										/*--------------------------------------------------------------------------------*/
										/* Adding Sidebar Item                                                            */
										/*--------------------------------------------------------------------------------*/
										<li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'} key={key}>
											<NavLink to={prop.path} className="sidebar-link" activeClassName="active">
												<i className={prop.icon} />
												<span className="hide-menu">{prop.name[lang]}</span>
											</NavLink>
										</li>
									)
								}
							})}
						</Nav>
					</PerfectScrollbar>
				</div>
			</aside>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
	  fetchUsers: query => dispatch(fetchUsers(query)),
  };
};

const mapStateToProps = state => ({
	isAuth: state.isAuth,
	users: state.users.users,
	location: state.router.location,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/sidebar.jsx